import { useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { joinClassAlert } from "@/lib/training";
import { inputCls } from "@/components/registration/ui";

export default function ClassAlertForm({ category, age }) {
  const [form, setForm] = useState({ parent_name: "", athlete_name: "", email: "" });
  const [state, setState] = useState({ busy: false, done: false, error: "" });
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const submit = async () => {
    if (!form.parent_name.trim() || !form.athlete_name.trim() || !/.+@.+\..+/.test(form.email)) {
      setState({ busy: false, done: false, error: "Parent name, athlete name and a valid email are required." });
      return;
    }
    setState({ busy: true, done: false, error: "" });
    try {
      await joinClassAlert({ category, age: Number(age), ...form });
      setState({ busy: false, done: true, error: "" });
    } catch (e) {
      setState({ busy: false, done: false, error: e?.response?.data?.detail || "Something went wrong. Please try again." });
    }
  };
  if (state.done) return <p data-testid="class-alert-success" className="mt-3 inline-flex items-center gap-2 text-sm font-bold text-emerald-300"><Check size={16} /> You're on the list. We'll email you once registration opens.</p>;
  return (
    <div data-testid="class-alert-form" className="mt-4 space-y-3">
      <p className="text-xs font-bold uppercase tracking-wider text-white/50">Get an email when registration opens</p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <input data-testid="class-alert-parent" value={form.parent_name} onChange={(e) => set("parent_name", e.target.value)} placeholder="Parent / guardian name *" className={inputCls} />
        <input data-testid="class-alert-athlete" value={form.athlete_name} onChange={(e) => set("athlete_name", e.target.value)} placeholder="Athlete name *" className={inputCls} />
        <input data-testid="class-alert-email" type="email" value={form.email} onChange={(e) => set("email", e.target.value)} placeholder="Email *" className={inputCls} />
      </div>
      {state.error && <p data-testid="class-alert-error" className="text-sm font-semibold text-red-400">{state.error}</p>}
      <button data-testid="class-alert-submit" onClick={submit} disabled={state.busy} className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-6 py-3 text-xs font-bold uppercase tracking-wider text-[#0B0F19] hover:bg-white/85 transition-colors">
        {state.busy ? <Loader2 size={16} className="animate-spin" /> : "Notify me"}
      </button>
    </div>
  );
}
